//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import {
  mdiEmailOutline,
  mdiSendOutline,
  mdiSquareEditOutline,
  mdiStarOutline,
  mdiAlertOctagonOutline,
  mdiTrashCanOutline,
} from '@mdi/js'
import { ref } from '@vue/composition-api'

// Local Components
import EmailComposeContent from './EmailComposeContent.vue'

export default {
  components: {
    // Local Components
    EmailComposeContent,

    // 3rd Party
    PerfectScrollbar,
  },
  props: {
    isEmailComposeDialogVisible: {
      type: Boolean,
      required: true,
    },
    emailsMeta: {
      type: Object,
      required: true,
    },
  },
  setup() {
    // Compose Dialog
    const isComposeDialogVisible = ref(false)
    const isEmailComposeDialogFullscreen = ref(false)

    const emailFilters = [
      { title: 'Inbox', icon: mdiEmailOutline, to: { name: 'apps-email' } },
      { title: 'Sent', icon: mdiSendOutline, to: { name: 'apps-email-folder', params: { folder: 'sent' } } },
      { title: 'Draft', icon: mdiSquareEditOutline, to: { name: 'apps-email-folder', params: { folder: 'draft' } } },
      { title: 'Starred', icon: mdiStarOutline, to: { name: 'apps-email-folder', params: { folder: 'starred' } } },
      { title: 'Spam', icon: mdiAlertOctagonOutline, to: { name: 'apps-email-folder', params: { folder: 'spam' } } },
      { title: 'Trash', icon: mdiTrashCanOutline, to: { name: 'apps-email-folder', params: { folder: 'trash' } } },
    ]

    const emailLabels = [
      { title: 'Personal', color: 'success', to: { name: 'apps-email-label', params: { label: 'personal' } } },
      { title: 'Company', color: 'primary', to: { name: 'apps-email-label', params: { label: 'company' } } },
      { title: 'Important', color: 'warning', to: { name: 'apps-email-label', params: { label: 'important' } } },
      { title: 'Private', color: 'error', to: { name: 'apps-email-label', params: { label: 'private' } } },
    ]

    const resolveFilterBadgeColor = filter => {
      if (filter === 'Draft') return 'primary'
      if (filter === 'Spam') return 'warning'

      return 'error'
    }

    // Perfect Scrollbar
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
      wheelSpeed: 0.7,
    }

    return {
      // Compose Dialog
      isComposeDialogVisible,
      isEmailComposeDialogFullscreen,

      // isDynamicRouteActive,
      resolveFilterBadgeColor,

      // Filter & Labels
      emailFilters,
      emailLabels,

      // Perfect Scrollbar
      perfectScrollbarSettings,
    }
  },
}
